(() => {
  const socketCollections = {
    h1: '/collections/h1',
    h4: '/collections/h2',
    h7: '/collections/ampoules-h7',
    h11: '/collections/ampoules-h8-h9-h11',
    hb3: '/search?q=HB3&type=product',
    hb4: '/search?q=HB4&type=product',
    h15: '/search?q=H15&type=product',
    d1: '/collections/ampoules-d1-d2-d3-d4',
  };

  const rangeCollections = {
    l15: '/collections/l15-60w',
    11: '/collections/1-1',
    i22: '/collections/i22-max-100w',
    quartz: '/collections/quartz-v2-120w',
    c36: '/collections/c36-pro-130w',
    c50: '/collections/c50-pro',
  };

  const rangeOrder = ['c50', 'c36', 'quartz', 'i22', '11', 'l15'];

  const rangeLabel = {
    l15: 'L15 · 60W',
    11: '1:1 · 80W',
    i22: 'I-22 Max · 100W',
    quartz: 'Quartz V2 · 120W',
    c36: 'C36 Pro · 130W',
    c50: 'C50 Pro · 150W',
  };

  const rangePrice = {
    l15: '39€',
    11: '49€',
    i22: '59€',
    quartz: '69€',
    c36: '79€',
    c50: '89€',
  };

  const products = {
    'c50|h1': 'c50-pro-h1',
    'c50|h4': 'c50-pro-h4',
    'c50|h7': 'c50-pro-h7',
    'c50|h11': 'c50-pro-h8-h9-h11',
    'c36|h1': 'c36-pro-h1',
    'c36|h4': 'c36-pro-h4',
    'c36|h7': 'c36-pro-h7',
    'c36|h11': 'c36-pro-h8-h9-h11',
    'c36|hb3': 'c36-pro-hb3-9005',
    'c36|hb4': 'c36-pro-hb4-9006',
    'c36|h15': 'c36-pro-h15',
    'c36|d1': 'c36-pro-d1-d2-d3-d4',
    'quartz|h1': 'quartz-v2-h1',
    'quartz|h7': 'quartz-v2-h7',
    'quartz|h11': 'quartz-v2-h8-h9-h11',
    'i22|h1': 'i22-max-h1',
    'i22|h4': 'i-22-max-h4',
    'i22|h7': 'i-22-max-h7',
    'i22|h11': 'i-22-max-h8-h9-h11',
    '11|h1': '1-1-h1',
    '11|h4': '1-1-h4',
    '11|h7': '1-1-h7',
    'l15|h1': 'l15-h1',
    'l15|h4': 'l15-h4',
    'l15|h7': 'l15-h7',
    'l15|h11': 'l15-h8-h9-h11',
    'l15|hb3': 'l15-hb3-9006',
    'l15|hb4': 'l15-hb4-9006',
  };

  const socketLabel = {
    h1: 'H1',
    h4: 'H4',
    h7: 'H7',
    h11: 'H8 / H9 / H11',
    hb3: 'HB3 / 9005',
    hb4: 'HB4 / 9006',
    h15: 'H15',
    d1: 'D1–D4',
  };

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const fill = (template, map) => {
    let out = template || '';
    Object.keys(map).forEach((key) => {
      out = out.replaceAll(`__${key.toUpperCase()}__`, map[key]);
    });
    return out;
  };

  const normalizeCulot = (raw) => {
    const key = String(raw || '').toLowerCase();
    const map = window.LIC_CULOT_NORMALIZE || {};
    return map[key] || key;
  };

  const productsForCulot = (culot) =>
    rangeOrder
      .filter((gamme) => products[`${gamme}|${culot}`])
      .map((gamme) => ({
        gamme,
        label: rangeLabel[gamme],
        price: rangePrice[gamme],
        handle: products[`${gamme}|${culot}`],
      }));

  const altsForCulot = (culot, skip) =>
    productsForCulot(culot).filter((item) => item.gamme !== skip);

  const init = (root) => {
    const base = (root.getAttribute('data-root') || '/').replace(/\/$/, '');
    const path = (url) => (base ? `${base}${url}` : url);

    const typeLabels = { voiture: 'Voiture', moto: 'Moto' };
    const vehicleSources = {
      voiture: window.LIC_VEHICLE_FITMENT || {},
      moto: window.LIC_VEHICLE_FITMENT_MOTO || {},
    };
    const typeOrder = Object.keys(vehicleSources).filter(
      (type) => Object.keys(vehicleSources[type]).length > 0
    );
    let currentType = typeOrder[0] || 'voiture';
    const fitment = () => vehicleSources[currentType] || {};

    const culotEl = root.querySelector('[data-fitment-culot]');
    const gammeEl = root.querySelector('[data-fitment-gamme]');
    const culotField = root.querySelector('[data-fitment-culot-field]');
    const brandEl = root.querySelector('[data-fitment-brand]');
    const brandField = root.querySelector('[data-fitment-brand-field]');
    const modelEl = root.querySelector('[data-fitment-model]');
    const modelField = root.querySelector('[data-fitment-model-field]');
    const positionEl = root.querySelector('[data-fitment-position]');
    const positionField = root.querySelector('[data-fitment-position-field]');
    const vehicleSubmit = root.querySelector('[data-fitment-vehicle-submit]');
    const vehicleResults = root.querySelector('[data-fitment-vehicle-results]');
    const ok = root.querySelector('[data-fitment-ok]');
    const submit = root.querySelector('[data-fitment-submit]');
    const modeBtns = root.querySelectorAll('[data-fitment-mode]');
    const panels = {
      socket: root.querySelector('[data-fitment-panel="socket"]'),
      vehicle: root.querySelector('[data-fitment-panel="vehicle"]'),
    };

    if (!brandEl || !modelEl || !positionEl || !vehicleSubmit) return;

    let typeEl = root.querySelector('[data-fitment-type]');
    if (!typeEl && typeOrder.length > 1 && brandField) {
      const wrap = document.createElement('label');
      wrap.className = 'lic-fitment__field';
      wrap.setAttribute('data-fitment-type-field', '');
      wrap.appendChild(document.createTextNode('Type de véhicule'));
      typeEl = document.createElement('select');
      typeEl.setAttribute('name', 'vehicle-type');
      typeEl.setAttribute('aria-label', 'Type de véhicule');
      typeEl.setAttribute('data-fitment-type', '');
      typeOrder.forEach((type) => {
        const opt = document.createElement('option');
        opt.value = type;
        opt.textContent = typeLabels[type] || type;
        typeEl.appendChild(opt);
      });
      wrap.appendChild(typeEl);
      brandField.parentNode.insertBefore(wrap, brandField);
      typeEl.addEventListener('change', () => {
        currentType = typeEl.value || 'voiture';
        brandEl.value = '';
        populateBrands();
        populateModels('');
      });
    }

    const msg = {
      need: root.getAttribute('data-msg-need') || '',
      confirmed: root.getAttribute('data-msg-confirmed') || '',
      range: root.getAttribute('data-msg-range') || '',
      missing: root.getAttribute('data-msg-missing') || '',
      available: root.getAttribute('data-msg-available') || '',
      seeAll: root.getAttribute('data-msg-see-all') || '',
      needBrand: root.getAttribute('data-msg-need-brand') || '',
      needModel: root.getAttribute('data-msg-need-model') || '',
      needPosition: root.getAttribute('data-msg-need-position') || '',
      vehicleFound: root.getAttribute('data-msg-vehicle-found') || '',
      vehicleDisclaimer: root.getAttribute('data-msg-vehicle-disclaimer') || '',
      pickRange: root.getAttribute('data-msg-pick-range') || '',
      noProduct: root.getAttribute('data-msg-no-product') || '',
    };

    const setOk = (html, warn) => {
      if (!ok) return;
      ok.hidden = !html;
      ok.classList.toggle('is-warn', Boolean(warn));
      ok.innerHTML = html || '';
    };

    const shake = (el) => {
      if (!el) return;
      el.classList.remove('is-shake');
      void el.offsetWidth;
      el.classList.add('is-shake');
    };

    const clearSelect = (el, placeholder) => {
      el.innerHTML = '';
      const opt = document.createElement('option');
      opt.value = '';
      opt.textContent = placeholder;
      el.appendChild(opt);
    };

    const populateBrands = () => {
      const brands = Object.keys(fitment()).sort((a, b) => a.localeCompare(b, 'fr'));
      const placeholder = brandEl.options[0]?.textContent || 'Select';
      clearSelect(brandEl, placeholder);
      brands.forEach((brand) => {
        const opt = document.createElement('option');
        opt.value = brand;
        opt.textContent = brand;
        brandEl.appendChild(opt);
      });
    };

    const populateModels = (brand) => {
      const placeholder = modelEl.getAttribute('data-placeholder') || modelEl.options[0]?.textContent || 'Select';
      clearSelect(modelEl, placeholder);
      modelEl.disabled = !brand;
      positionEl.disabled = true;
      positionEl.value = '';
      if (vehicleResults) {
        vehicleResults.hidden = true;
        vehicleResults.innerHTML = '';
      }
      if (!brand || !fitment()[brand]) return;
      Object.keys(fitment()[brand]).forEach((model) => {
        const opt = document.createElement('option');
        opt.value = model;
        opt.textContent = model;
        modelEl.appendChild(opt);
      });
    };

    const setMode = (next) => {
      const mode = next === 'socket' ? 'socket' : 'vehicle';
      root.setAttribute('data-mode', mode);
      modeBtns.forEach((btn) => {
        const active = btn.getAttribute('data-fitment-mode') === mode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (panels.socket) panels.socket.hidden = mode !== 'socket';
      if (panels.vehicle) panels.vehicle.hidden = mode !== 'vehicle';
      if (mode === 'vehicle') setOk('', false);
    };

    const renderVehicleResults = (culot, meta) => {
      const socket = socketLabel[culot] || culot.toUpperCase();
      const list = productsForCulot(culot);
      const headline = fill(msg.vehicleFound, {
        brand: meta.brand,
        model: meta.model,
        position: meta.positionLabel,
        socket,
      });

      if (!list.length) {
        const allHref = path(socketCollections[culot] || '/collections/all');
        setOk(
          `${fill(msg.noProduct, { socket })} <a href="${allHref}">${fill(msg.seeAll, { socket })}</a>`,
          true
        );
        if (vehicleResults) {
          vehicleResults.hidden = true;
          vehicleResults.innerHTML = '';
        }
        return;
      }

      setOk(headline, false);

      const cards = list
        .map((item) => {
          const href = path(`/products/${item.handle}`);
          return `<a class="lic-fitment__product" href="${href}">
            <span class="lic-fitment__product-name">${item.label}</span>
            <span class="lic-fitment__product-meta">${socket} · ${item.price}</span>
          </a>`;
        })
        .join('');

      const allHref = path(socketCollections[culot] || '/collections/all');
      if (vehicleResults) {
        vehicleResults.hidden = false;
        vehicleResults.innerHTML = `
          <p class="lic-fitment__results-kicker">${msg.pickRange}</p>
          <div class="lic-fitment__product-grid">${cards}</div>
          <p class="lic-fitment__results-note">${msg.vehicleDisclaimer}</p>
          <a class="lic-fitment__results-all" href="${allHref}">${fill(msg.seeAll, { socket })} →</a>
        `;
      }
    };

    const findForVehicle = () => {
      const brand = brandEl.value;
      const model = modelEl.value;
      const position = positionEl.value;
      const positionLabel =
        positionEl.options[positionEl.selectedIndex]?.textContent || position;

      if (!brand) {
        setOk(msg.needBrand, true);
        shake(brandField || brandEl);
        brandEl.focus();
        return;
      }
      if (!model) {
        setOk(msg.needModel, true);
        shake(modelField || modelEl);
        modelEl.focus();
        return;
      }
      if (!position) {
        setOk(msg.needPosition, true);
        shake(positionField || positionEl);
        positionEl.focus();
        return;
      }

      const raw = fitment()[brand]?.[model]?.[position];
      const culot = normalizeCulot(raw);
      if (!culot) {
        setOk(msg.needPosition, true);
        return;
      }

      vehicleSubmit.classList.remove('is-flash');
      void vehicleSubmit.offsetWidth;
      vehicleSubmit.classList.add('is-flash');

      renderVehicleResults(culot, { brand, model, positionLabel });
    };

    const goSocket = () => {
      if (!culotEl || !gammeEl || !submit) return;
      const culot = culotEl.value;
      const gamme = gammeEl.value;
      const socket = socketLabel[culot] || culot;

      if (!culot && (!gamme || gamme === 'all')) {
        setOk(msg.need, true);
        shake(culotField || culotEl);
        culotEl.focus();
        return;
      }

      const key = `${gamme}|${culot}`;
      const handle = culot && gamme && gamme !== 'all' ? products[key] : null;

      if (culot && gamme && gamme !== 'all' && !handle) {
        const alts = altsForCulot(culot, gamme);
        const altHtml = alts
          .map((item) => `<a href="${path(`/products/${item.handle}`)}">${item.label}</a>`)
          .join(', ');
        const allHref = path(socketCollections[culot] || '/collections/all');
        const missing = fill(msg.missing, { range: rangeLabel[gamme] || gamme, socket });
        const seeAll = `<a href="${allHref}">${fill(msg.seeAll, { socket })}</a>`;
        setOk(
          `${missing} ${alts.length ? `${msg.available} ${altHtml}. ` : ''}${seeAll}`,
          true
        );
        shake(submit);
        return;
      }

      setOk(culot ? fill(msg.confirmed, { socket }) : msg.range, false);

      let url;
      if (handle) url = path(`/products/${handle}`);
      else if (culot) url = path(socketCollections[culot] || '/collections/all');
      else url = path(rangeCollections[gamme] || '/collections/all');

      submit.classList.remove('is-flash');
      void submit.offsetWidth;
      submit.classList.add('is-flash');

      window.setTimeout(() => {
        window.location.assign(url);
      }, reduce ? 0 : 180);
    };

    populateBrands();

    brandEl.addEventListener('change', () => {
      populateModels(brandEl.value);
      if (brandEl.value) modelEl.disabled = false;
    });

    modelEl.addEventListener('change', () => {
      positionEl.disabled = !modelEl.value;
      positionEl.value = '';
      if (vehicleResults) {
        vehicleResults.hidden = true;
        vehicleResults.innerHTML = '';
      }
    });

    modeBtns.forEach((btn) => {
      btn.addEventListener('click', () => setMode(btn.getAttribute('data-fitment-mode')));
    });

    vehicleSubmit.addEventListener('click', findForVehicle);
    if (submit) submit.addEventListener('click', goSocket);

    setMode('socket');
  };

  document.querySelectorAll('[data-lic-fitment]').forEach(init);
})();
